import Chip from '@material-ui/core/Chip'
import { Typography } from '@material-ui/core'
import NobaarStepper from '../NobaarStepper'
import Skeleton from '@material-ui/lab/Skeleton'
import React from 'react'
import i18n from '../../../i18nextInitiator'
import Pay from './Pay'
import CancelOrder from './CancelOrder/CancelOrder'
import Grid from '@material-ui/core/Grid'
import {
	bindingParamsToPath,
	getOrderStateId,
	paths,
} from '../../../actions/actionCreators'
import Button from '@material-ui/core/Button'
import { store } from '../../../store'
import { push } from 'connected-react-router'
import ProgressTruck from './Progress/ProgressTruck'
import IntroMessageBox from './IntroMessageBox'
import { connect } from 'react-redux'
import ProviderInfo from './ProviderInfo/ProviderInfo'
import { useHistory } from 'react-router-dom'
import IntercityMessage from './IntercityMessage'

/**
 * translate function.
 * @type {TFunction}
 */
const t = i18n.getFixedT('fa', 'general')
/**
 * maps redux states to component props.
 * @param state
 */
const mapStateToProps = (state) => ({ ...state.invoice })

/**
 * This component handles the top box of the the tracker page.
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
const TopBox = (props) => {
	const history = useHistory()
	const { bill: { can_comment, comment } = {} } = props
	/**
	 * Comment Btn. Displays when order status is ended or above.
	 * @return {JSX.Element|null}
	 * @constructor
	 */
	const CommentBtn = () => {
		if (can_comment && !comment)
			return (
				<>
					<br />
					<Button
						variant={'contained'}
						fullWidth
						color={'secondary'}
						onClick={() =>
							store.dispatch(push(bindingParamsToPath(props.id, paths.comment)))
						}>
						{`${t('submit')} ${t('rating.comment')}`}
					</Button>
				</>
			)
		return null
	}

	if (props.status === getOrderStateId('cancelled')) {
		return (
			<div style={{ textAlign: 'center' }}>
				<Chip
					color={'secondary'}
					label={t('canceled-order')}
					style={{ fontSize: '1rem' }}
					variant={'outlined'}></Chip>
			</div>
		)
	}

	if (props.status === getOrderStateId('submitted')) {
		return (
			<div>
				{!history.location.pathname.includes('tracking/intercity') ? (
					<ProgressTruck />
				) : (
					<IntercityMessage />
				)}
				<IntroMessageBox />
				{!history.location.pathname.includes('tracking/intercity') && (
					<CancelOrder />
				)}
			</div>
		)
	}

	if (props.status > getOrderStateId('submitted')) {
		return (
			<Grid>
				<Grid container justifyContent={'flex-end'}>
					<CancelOrder />
				</Grid>
				<Grid justifyContent={'center'} container>
					<NobaarStepper status={props.status} />
					<br />
					<Pay />
					<ProviderInfo {...props} />
				</Grid>
				<CommentBtn />
			</Grid>
		)
	}

	return (
		<Typography>
			<Skeleton animation={'wave'} />
		</Typography>
	)
}
export default connect(mapStateToProps)(TopBox)
